// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sspNhLW0wj8zCF_RJoi5{background-color:var(--black-10);border-radius:6px;align-items:center;gap:4px;width:-webkit-fit-content;width:fit-content;padding:4px 8px;display:flex}.sspNhLW0wj8zCF_RJoi5.QvWKaLSyCogqGTvqTHpn:hover{cursor:pointer}.VhmyrTKKwfosjVk0CjBn{opacity:.5;pointer-events:none}.aP9jpUc9a1kElqROy83v{text-transform:capitalize}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"roleChip": `sspNhLW0wj8zCF_RJoi5`,
	"hoverState": `QvWKaLSyCogqGTvqTHpn`,
	"disabled": `VhmyrTKKwfosjVk0CjBn`,
	"capitalize": `aP9jpUc9a1kElqROy83v`
};
export default ___CSS_LOADER_EXPORT___;
